export const MODE = {
    'DEV': 'DEV',
    'STAG': 'STAG',
    'PROD': 'PROD',
    'UNKNOWN': 'UNKNOWN'
}